import { copies } from '@reveni-io/reveni-ui'

import { copiesKeyMap } from './constants'

export const getRequestSummaryMessage = (fullKey, customCopies, lang) => {
  const customMessage = customCopies?.[lang]?.[fullKey]?.message

  if (customMessage) return customMessage

  return copies[lang]?.requestSummary?.[copiesKeyMap[fullKey]] || ''
}
